import { type HTMLArkProps, ark } from "@ark-ui/react";
import clsx from "clsx";
import * as React from "react";
import type { FontWeightProps } from "../../helper/FontWeightProps.js";

export type TextSize = "xl" | "lg" | "md" | "sm";
interface TextProps extends HTMLArkProps<"p">, FontWeightProps {
  size?: TextSize;
  className?: string;
}

const Text = React.forwardRef<HTMLParagraphElement, TextProps>((props, ref) => {
  const { className, size = "lg", fontWeight = "regular", ...rest } = props;

  return (
    <ark.p
      data-size={size}
      data-font-weight={fontWeight}
      className={clsx("ox-reset ox-ui-Text", className)}
      {...rest}
      ref={ref}
    />
  );
});

Text.displayName = "Text";
export { Text };
export type { TextProps };
